import React from 'react';
import styled from 'styled-components';

const StyledFooter = styled.footer`
  display: none; /* Hide the footer */
`;

// Hidden for now — kept as the place to add a site footer later
const Footer = () => <StyledFooter />;

export default Footer;
